import React from 'react'

export const FacebookIconHome = () => {
    return (
        <div>
            <svg height="28px" width="28px" viewBox="0 0 24 49" fill="#FCE5D8"><path d="M15 49V26.6h8.4l.6-8.2h-9v-6.1c0-2.7.7-4.1 3.5-4.1h5.2L24 .4h-.8A41.4 41.4 0 0 0 18 0c-4 0-7 1.1-9 3.2a11.2 11.2 0 0 0-3 8v7.2H0v8.2h6V49h9z"></path></svg>
        </div>
    )
}
